export const ExperimentsAPI = {
    name: 'EXPERIMENTS_API',
    layer: 'SITE',
    public: true,
};
//# sourceMappingURL=experimentsAPI.js.map